export var ENUM = {
  // 事件
  EVENT_CHANGE_HOSPITAL: 'CHANGE_HOSPITAL',
  // 机构管理切换医院
  USER_PROFILE_UPLOAD: 'PROFOLE_UPLOAD',
  // 个人中心个人资质上传
  NAVBAR_MESSAGE_INDEX_REDUCE: 'MY_MESSAGE_INDEX_REDUCE',
  // 个人站内信index减
  NAVBAR_NOTICE_INDEX_REDUCE: 'MY_NOTICE_INDEX_REDUCE',
  // 个人站内信index减
  SWITCH_PROJECT: 'CLOSE_All_TAGS' // 切换项目  关闭所有标签
  //RESET_AREA_FORM: 'RESET_AREA_FORM', // 受试者  切换访视 数据域变量(area组件) 的form 清空
};